export interface PlaybookBullet {
  id: string;
  text: string;
  legacyId?: string;
}

interface ApiBullet {
  id: string;
  text: string;
}

export function resolvePlaybookBullets(
  texts: string[],
  items: ApiBullet[] | undefined,
  prefix: 'pitch' | 'advanced',
  legacyTexts: Record<string, string> = {}
): PlaybookBullet[] {
  return texts.map((text, index) => {
    const fallbackId = `${prefix}-${index}`;
    const item = items?.[index];
    const id = item?.id && item.text === text ? item.id : fallbackId;
    const matchingLegacyIds = Object.entries(legacyTexts)
      .filter(([key, savedText]) => key.startsWith(`${prefix}-`) && savedText === text)
      .map(([key]) => key);
    const currentMatches = texts.filter((candidate) => candidate === text).length;
    const legacyId = id !== fallbackId && matchingLegacyIds.length === 1 && currentMatches === 1
      ? matchingLegacyIds[0]
      : undefined;
    return {
      id,
      text,
      legacyId,
    };
  });
}

export function migrateLegacyBulletTracking<T>(
  checked: string[],
  notes: Record<string, T>,
  bullets: PlaybookBullet[]
): { checked: string[]; notes: Record<string, T> } {
  const ids = new Map(bullets.filter(({ legacyId }) => legacyId).map(({ id, legacyId }) => [legacyId as string, id]));
  const migratedNotes: Record<string, T> = {};

  for (const [key, note] of Object.entries(notes)) {
    const target = ids.get(key) || key;
    // A note already keyed by the stable ID wins over its legacy duplicate.
    if (!(target in notes) || target === key) migratedNotes[target] = note;
  }

  return {
    checked: Array.from(new Set(checked.map((id) => ids.get(id) || id))),
    notes: migratedNotes,
  };
}
